import React, { useState } from 'react';
import { TokensVService } from '../../../services/V3/gozer';
import { AchTokensVService } from '../../../services/V2/longhorn';
import { handleChange, handleError } from '../../shared/Functions';
import { Button, CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField } from '@material-ui/core';

export default function ThirdPartyACH({ account, success, fail, close }) {
    const [model, setModel] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);
    const [routingNumberCheck, setRoutingNumberCheck] = useState<any>({isGood: true});

    const createToken = () => {
        setLoading(true)
        TokensVService.tokensVCreateThirdPartyAch(account.id, model)
            .then(x => {
                setRoutingNumberCheck(x)
                setLoading(false)
                success()
            })
            .catch(err => {
                err.message !=="Not Found" && fail(handleError(err))
                setLoading(false)
            })
    }

    const checkRoutingNumber = () => {
        setLoading(true)
        AchTokensVService.achTokensVCheckRoutingNumber(model.routingNumber)
            .then(x => {
                setRoutingNumberCheck(x)
                setLoading(false)
            })
            .catch(err => {
                err.message !=="Not Found" && fail(handleError(err))
                setLoading(false)
            })
    }

    return <>
        {(loading) && <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>}
        <Dialog
            onClose={() => { }}
            open={true}>
            <DialogTitle>Authorization for Automated Bank Draft</DialogTitle>
            <DialogContent>
                <FormControl style={{width:"100%", marginTop: "16px", marginBottom: "10px", textAlign: "left"}}>
                    <FormLabel>Enter Bank Information</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="achType"
                        defaultValue=""
                        name="achType"
                        value={model.achType}
                        onChange={e => setModel({
                            ...model,
                            achType: e.target.value
                        })}
                    >
                        <FormControlLabel value="" control={<span style={{marginLeft:"10px"}}></span>} label="Account Type:" />
                        <FormControlLabel value="Checking" control={<Radio />} label="Checking" />
                        <FormControlLabel value="Savings" control={<Radio />} label="Savings" />
                    </RadioGroup>
                </FormControl>
                <Grid container >
                    <Grid xs={6}>
                        <TextField
                            onChange={e => handleChange(e, model, setModel)}
                            margin="normal"
                            label={"First Name"}
                            type="text"
                            value={model.firstName}
                            fullWidth
                            autoComplete="firstName"
                            name="firstName"
                            
                        />
                    </Grid>
                    <Grid xs={6}>
                        <TextField
                            onChange={e => handleChange(e, model, setModel)}
                            margin="normal"
                            label={"Last Name"}
                            type="text"
                            value={model.lastName}
                            fullWidth
                            autoComplete="lastName"
                            name="lastName"
                        />
                    </Grid>
                </Grid>
                <TextField
                    onChange={e => handleChange(e, model, setModel)}
                    onBlur={checkRoutingNumber}
                    margin="normal"
                    label={"Routing Number"}
                    type="text"
                    value={model.routingNumber}
                    fullWidth
                    autoComplete="routingNumber"
                    helperText={routingNumberCheck.bankName ?? routingNumberCheck.error}
                    name="routingNumber"
                />
                <TextField
                    onChange={e => handleChange(e, model, setModel)}
                    margin="normal"
                    label={"Account Number"}
                    type="text"
                    value={model.accountNumber}
                    fullWidth
                    autoComplete="accountNumber"
                    name="accountNumber"
                />
                <TextField
                    margin="normal"
                    label={"Confirm Account Number"}
                    type="text"
                    onChange={e => handleChange(e, model, setModel)}
                    value={model.accountNumberConfirmation}
                    fullWidth
                    autoComplete="accountNumber"
                    helperText={model.accountNumberConfirmation === model.accountNumber ? "" : "Must match Account Number"}
                    name="accountNumberConfirmation"
                />
                <div style={{ fontSize: "16px" }}>
                    By submitting this form, I authorize {account.districtInfo.name} to automatically withdraw payments for my utility services from the bank account specified
                    above.
                    <br />
                    <br />
                    I understand that I must notify {account.districtInfo.name} in writing at least 1 day before the next scheduled debit if I wish to update my bank information
                    or revoke this authorization.
                    <br />
                    <br />
                    I acknowledge that it is my responsibility to ensure sufficient funds are available in my account on each scheduled debit date. If a payment is returned
                    unpaid, I understand that {account.districtInfo.name} may charge applicable fees as permitted by law and that my utility service may be subject to interruption
                    according to company policy.
                </div>
                <div className='payment-modal-buttons-group'>
                    <Button
                        disabled={!model.achType ||
                            !model.firstName ||
                            !model.lastName ||
                            !model.accountNumber ||
                            !model.routingNumber ||
                            model.accountNumber !== model.accountNumberConfirmation ||
                            !routingNumberCheck.isGood}
                        variant="contained"
                        color="primary"
                        onClick={() => createToken()}
                        className="m-2">Save</Button>
                </div>
                <div className='payment-modal-buttons-group'>
                    <Button variant="contained"
                        color="secondary"
                        onClick={close}
                        className="m-2">Cancel</Button>
                </div>
            </DialogContent>
        </Dialog>
    </>
}